import React, { useEffect, useState,useContext } from 'react'
import SidebarContent from './SidebarContent'
import HalfDesktopSidebar from './HalfDesktopSidebar'
import { Icon } from '../../assets/icons'
import { LanguageContext } from '../../i18n/LanguageContext'
import ServerIP from '../../utils/serverIp'

function DesktopSidebar({ initLoading }) {
  const [open, setOpen] = useState(false)
  const { language } = useContext(LanguageContext)
  // useEffect(() => {
  //   window.innerWidth < 1300 ? setOpen(false) : setOpen(true)
  // }, [])
  return (
    <div className='static step1'>
      {(open) ? (
        <>
          <aside className="h-screen sticky top-0 overflow-y-auto inset-y-0 left-0 z-30 flex-shrink-0 hidden w-72 overflow-y-auto bg-side_bar_bg md:flex md:flex-col">
            <SidebarContent />
            {/* In normal flow (pushed down by mt-auto) so on a short screen it follows the menu instead of sitting on top of the last items. */}
            <div className="mt-auto flex shrink-0 items-center gap-2 px-4 pb-4 pt-3">
              <ServerIP simple />
              <span className="text-[11px] font-semibold text-gray-800">-SolyntekAi-</span>
            </div>
          </aside>
          {!initLoading && (
          <div className={`fixed hidden md:flex top-1/2 -translate-y-1/2 -translate-x-1/2 ${language === 'ar' ? 'right-72' : 'left-72'} z-40 bg-white border rounded-lg p-1 shadow-lg`}>
            <button className='text-black' title="Collapse sidebar" aria-label="Collapse sidebar" onClick={() => setOpen(!open)} >
              <Icon className="w-5 h-5 text-blue" aria-hidden="true" icon={`${language === 'ar' ? 'ArrowRight' : 'ArrowLeft'}`} />
            </button>
          </div>
          )}
        </>

      ) : (
        <>
        {!initLoading && (
          <div className={`fixed hidden md:flex top-1/2 -translate-y-1/2 -translate-x-1/2 ${language === 'ar' ? 'right-24' : 'left-24'} z-40 bg-white border rounded-lg p-1 shadow-lg`}>
            <button className='text-black' title="Expand sidebar" aria-label="Expand sidebar" onClick={() => setOpen(!open)} >
              <Icon className="w-5 h-5 text-blue" aria-hidden="true" icon={`${language === 'ar' ? 'ArrowLeft' : 'ArrowRight'}`} />
            </button>
          </div>
        )}
          <aside className="h-screen sticky top-0 overflow-y-auto inset-y-0 left-0 z-30 flex-shrink-0 hidden w-24 overflow-y-auto bg-side_bar_bg md:flex md:flex-col">
            <HalfDesktopSidebar />
            <div className="mt-auto flex shrink-0 flex-col items-center gap-1 pb-2 pt-3">
              <ServerIP simple />
              <span className="text-[9px] font-semibold text-gray-800">-SolyntekAi-</span>
            </div>
          </aside>


        </>
      )}


    </div>


  )
}

export default DesktopSidebar